import { cart } from './cart.i18n';

export const fr = {
  cart,
};
